import React from 'react';

import { BusinessUnits, BusinessUnitsFR, Config } from '@ratehub/base-ui';
import { CCSideBySide } from '@ratehub/web-components';
import { LazyCreditCardComparisonTray } from '@ratehub/cc-common';

import getBlockOfTypeRecursively from './getBlockOfTypeRecursively';


/**
 * Based on the page’s businessUnit, this may decide to add one or more components to the page.
 * @param {object} args - object-based argument
 * @param {string} args.businessUnit - _localized_ business unit assigned in the CMS
 * @param {object[]} args.pageBlocks - an array of top-level CMS blocks on the page in question
 * @returns {(React.JSX.Element[]|null)} - null when requirements are not met
 */
function getConditionalComponents({ businessUnit, pageBlocks }) {
    if (Config.ENABLE_CC_COMPARISON_DOCUMENT
        && (businessUnit === BusinessUnits.CREDIT_CARDS || businessUnit === BusinessUnitsFR.CREDIT_CARDS)
    ) {
        // Credit cards should NOT add the CreditCardComparisonTray on pages that have the cc-side-by-side block
        if (pageBlocks.some(
            block => getBlockOfTypeRecursively(block, [ CCSideBySide.blockKey ])
        )) {
            return null;
        }

        return [
            <LazyCreditCardComparisonTray key="creditCardComparisonTray" />,
        ];
    }

    return null;
}


export default getConditionalComponents;
